
































import * as moment from "moment";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { hasTranslation } from "@/lang/i18n";
import { PresetField } from "@/model/data.model";

@Component
export default class SearchResults extends Vue {
  @Prop({ required: true })
  presets!: PresetField[];

  @Prop({ required: true })
  rows!: any[];

  @Prop({ default: false })
  loading!: boolean;

  get visiblePresets(): PresetField[] {
    return this.presets.filter(p => p.visible);
  }

  columnLabel(preset: PresetField): string {
    const key = preset.field;
    const translated = this.$t ? this.$t(key) : key;
    return (translated as any) || key;
  }

  getMinWidth(preset: PresetField): number {
    if (preset.type === "DATE") return 130;
    if (preset.type === "BOOLEAN") return 90;
    return 150;
  }

  getValue(row: any, path: string): any {
    if (!row || !path) return null;

    const segments = path.split(".");
    let current: any = row;

    for (const seg of segments) {
      if (current == null) return null;

      const match = seg.match(/^(\w+)\[(\d+)\]$/);
      if (match) {
        const prop = match[1];
        const index = Number(match[2]);
        current = current[prop];
        if (!Array.isArray(current)) return null;
        current = current[index];
        if (match[1] === "notes" && current) {
          return current.text ?? "";
        }
      } else {
        current = current[seg];
      }
    }

    return current;
  }

  formatValue(value: any, preset: PresetField): any {
    if (!value) return "-";

    switch (preset.type) {
      case "DATE":
        return moment(value).format("DD/MM/YYYY");

      default:
        if (typeof value === "number") {
          return value.toFixed(2);
        }
        return hasTranslation(value) ? this.$t(value) : value;
    }
  }
}
